import React, { useEffect } from 'react';
import './ErrorToast.css';

interface ErrorToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
}

export const ErrorToast: React.FC<ErrorToastProps> = ({
  message,
  isVisible,
  onClose,
}) => {
  useEffect(() => {
    let timer: number;
    if (isVisible) {
      timer = window.setTimeout(() => {
        onClose();
      }, 10000);
    }

    return () => {
      if (timer) {
        window.clearTimeout(timer);
      }
    };
  }, [isVisible, onClose]);

  // Don't render if no message or not visible
  if (!message || !isVisible) return null;

  return (
    <div className={`toast-container ${isVisible ? 'visible' : ''}`}>
      <span>{message}</span>
      <button className="close-button" onClick={onClose}>
        &times;
      </button>
    </div>
  );
};
